<h3 mat-dialog-title>{{ paramUpload.title }}</h3>
<div mat-dialog-content style="width: 100%">
    <p>
        Faça um upload de um arquivo XLS, no formato do arquivo modelo. <br>
        <a href="{{utiliesService.server + paramUpload.urlModelDownload}}">Faça download do arquivo modelo.</a>
        <br>
        <b>OBS.: Siga o modelo em anexo, mas, adicione apenas as linhas com o conteúdo que será importado.</b>
    </p>    

    <div 
        fxLayout="row" 
        fxLayoutAlign="space-between"
    >
        <mat-form-field 
            appearance="outline" 
            floatLabel="always" 
            fxFlex="100"
        >
            <mat-label>Data Referência</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker" 
                [formControl]="data_referencia" 
                name="data_referencia" 
                placeholder="Data de Nascimento"
            >
            <mat-datepicker-toggle matSuffix [for]="picker">
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>

    <input 
        hidden 
        type="file" 
        #fileInput 
        (change)="uploadFile($event)" 
        ng2FileSelect 
        [uploader]="uploader" 
        [accept]="['.xls','.xlsx']"
        [(ngModel)]="hasFile"
    />
    
    <button 
        mat-button 
        (click)="fileInput.click()" 
        tabindex="-1" 
        [disabled]="uploader.queue.length > 0" 
    >
        <mat-icon>cloud_upload</mat-icon>
        Importar Arquivo
    
    </button>

    <p *ngFor="let item of uploader.queue">
        <b>{{nomeFile}}</b> 
        <button 
            type="button" 
            mat-button 
            tabindex="-1" 
            (click)="item.remove()"
        >
            X
        </button>
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button 
        type="button"
        mat-button
        (click)="startUpload()"
        [disabled]="isInvalidForm()"
        tabindex="-1" >
        Enviar
    </button>
</div>
